
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexXmqE5xTwtT0gTfRG37w17wodizlgKaCmFVp_45WzpZdN0Meta } from "/app/src/pages/seminar/202506/index.vue?macro=true";
import { default as index9UgqkC3vcOnaDPNlHUtTlOVDwluCUX_45KG8EMu2sggHwMeta } from "/app/src/pages/seminar/202509/index.vue?macro=true";
import { default as index2rAgTMQFEmWDqa0uRvblSPCLn3PmWHrDza13KxNkD3IMeta } from "/app/src/pages/seminar/202512/index.vue?macro=true";
import { default as indexYbXxSCz_45ePWD8HYWAWNQ2zZ3Q5qVDePdjZ_NeA_BzFQMeta } from "/app/src/pages/seminar/202603/index.vue?macro=true";
import { default as thanks4_45WKmTZRSspAQ7Vhb1HZSYOb7hDKixw4Rya0W_3Du40Meta } from "/app/src/pages/seminar/202506/thanks.vue?macro=true";
import { default as thankshZzo_45PkfDyfQpvz1xrP2tSYLv8z6NMUMfs9vesAhPxIMeta } from "/app/src/pages/seminar/202509/thanks.vue?macro=true";
import { default as thanks4THOT_xFfLlGyYq1dPIKnci3v0CjCTatGFJQHkJjOpwMeta } from "/app/src/pages/seminar/202512/thanks.vue?macro=true";
import { default as thanks7dTYhop33gfN2xJlUl3nXzj0JVlEkY3oX4bGXlAEiQIMeta } from "/app/src/pages/seminar/202603/thanks.vue?macro=true";
import { default as component_45stub5gHjJVnEb5umaPpvzLxUeU4TZ4Nz2raYMC6r_451mgTLYMeta } from "/app/node_modules/.pnpm/nuxt@3.17.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_io_45f5835dc264c2769e464e2e6205b9bf/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5gHjJVnEb5umaPpvzLxUeU4TZ4Nz2raYMC6r_451mgTLY } from "/app/node_modules/.pnpm/nuxt@3.17.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_io_45f5835dc264c2769e464e2e6205b9bf/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "seminar-202506",
    path: "/seminar/202506",
    meta: indexXmqE5xTwtT0gTfRG37w17wodizlgKaCmFVp_45WzpZdN0Meta || {},
    component: () => import("/app/src/pages/seminar/202506/index.vue")
  },
  {
    name: "seminar-202509",
    path: "/seminar/202509",
    meta: index9UgqkC3vcOnaDPNlHUtTlOVDwluCUX_45KG8EMu2sggHwMeta || {},
    component: () => import("/app/src/pages/seminar/202509/index.vue")
  },
  {
    name: "seminar-202512",
    path: "/seminar/202512",
    meta: index2rAgTMQFEmWDqa0uRvblSPCLn3PmWHrDza13KxNkD3IMeta || {},
    component: () => import("/app/src/pages/seminar/202512/index.vue")
  },
  {
    name: "seminar-202603",
    path: "/seminar/202603",
    meta: indexYbXxSCz_45ePWD8HYWAWNQ2zZ3Q5qVDePdjZ_NeA_BzFQMeta || {},
    component: () => import("/app/src/pages/seminar/202603/index.vue")
  },
  {
    name: "seminar-202506-thanks",
    path: "/seminar/202506/thanks",
    meta: thanks4_45WKmTZRSspAQ7Vhb1HZSYOb7hDKixw4Rya0W_3Du40Meta || {},
    component: () => import("/app/src/pages/seminar/202506/thanks.vue")
  },
  {
    name: "seminar-202509-thanks",
    path: "/seminar/202509/thanks",
    meta: thankshZzo_45PkfDyfQpvz1xrP2tSYLv8z6NMUMfs9vesAhPxIMeta || {},
    component: () => import("/app/src/pages/seminar/202509/thanks.vue")
  },
  {
    name: "seminar-202512-thanks",
    path: "/seminar/202512/thanks",
    meta: thanks4THOT_xFfLlGyYq1dPIKnci3v0CjCTatGFJQHkJjOpwMeta || {},
    component: () => import("/app/src/pages/seminar/202512/thanks.vue")
  },
  {
    name: "seminar-202603-thanks",
    path: "/seminar/202603/thanks",
    meta: thanks7dTYhop33gfN2xJlUl3nXzj0JVlEkY3oX4bGXlAEiQIMeta || {},
    component: () => import("/app/src/pages/seminar/202603/thanks.vue")
  },
  {
    name: component_45stub5gHjJVnEb5umaPpvzLxUeU4TZ4Nz2raYMC6r_451mgTLYMeta?.name,
    path: "/",
    component: component_45stub5gHjJVnEb5umaPpvzLxUeU4TZ4Nz2raYMC6r_451mgTLY
  }
]